export function initAudioPlayer() {
  const buttons = document.querySelectorAll('.track__button');
  let currentAudio = null;
  let currentButton = null;
  let progressInterval = null;

  function updateProgress(audio, progressCircle) {
    const duration = audio.duration;
    const currentTime = audio.currentTime;
    const progress = (currentTime / duration) * 100;

    const circumference = 2 * Math.PI * 16;
    const offset = circumference - ((100 - progress) / 100) * circumference; // Reversed calculation
    progressCircle.style.strokeDashoffset = offset;
  }

  buttons.forEach(button => {
    const progressSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    progressSvg.classList.add('track__progress');
    progressSvg.setAttribute('viewBox', '0 0 34 34');

    const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    circle.setAttribute('cx', '17');
    circle.setAttribute('cy', '17');
    circle.setAttribute('r', '16');
    circle.setAttribute('stroke-width', '1');
    circle.setAttribute('fill', 'none');

    const circumference = 2 * Math.PI * 16;
    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference; // Start empty

    progressSvg.appendChild(circle);
    button.insertBefore(progressSvg, button.firstChild);

    button.addEventListener('click', function() {
      const audioSrc = this.dataset.audio;
      const progressCircle = this.querySelector('circle');

      if (currentButton === this && currentAudio?.paused === false) {
        currentAudio.pause();
        this.classList.remove('is-playing');
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
        progressCircle.style.strokeDashoffset = circumference; // Reset to empty
        return;
      }

      if (currentAudio && currentButton) {
        currentAudio.pause();
        currentButton.classList.remove('is-playing');
        if (progressInterval) {
          clearInterval(progressInterval);
          progressInterval = null;
        }
        const prevCircle = currentButton.querySelector('circle');
        if (prevCircle) prevCircle.style.strokeDashoffset = circumference; // Reset to empty
      }

      if (currentButton !== this || currentAudio?.paused === true) {
        if (currentButton !== this) {
          currentAudio = new Audio(audioSrc);
        }

        currentButton = this;
        currentAudio.play();
        this.classList.add('is-playing');

        // Start with empty circle
        progressCircle.style.strokeDasharray = circumference;
        progressCircle.style.strokeDashoffset = circumference;

        progressInterval = setInterval(() => {
          updateProgress(currentAudio, progressCircle);
        }, 50);

        currentAudio.onended = () => {
          this.classList.remove('is-playing');
          clearInterval(progressInterval);
          progressInterval = null;
          progressCircle.style.strokeDashoffset = circumference; // Reset to empty
        };
      }
    });
  });
}